var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContactContext } from "@/contexts/contact/hooks";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { TextArea } from "@gemini/ui";
import { useState } from "react";
import { Controller } from "react-hook-form";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const MessageInput = ({ contactFormDatas, control, required, }) => {
    const { t } = useI18n();
    const { subjectLabel } = contactFormDatas;
    const [showMessageInput, setShowMessageInput] = useState(false);
    const { defaultMessage } = useContactContext();
    const isPreviewMode = useIsPreviewMode();
    return (_jsxs(_Fragment, { children: [_jsx(Box, { children: _jsx(Box, { onClick: () => setShowMessageInput(!showMessageInput), display: "inline-block", marginRight: "spacing.4", cursor: "pointer", typography: {
                        "breakpoint.base": "typography.body.16.boldUnderlined",
                    }, children: t("contact.form.add_additional_message_label") }) }), showMessageInput && (_jsx(Controller, { name: "message", control: control, defaultValue: defaultMessage, render: (_a) => {
                    var _b = _a.field, { value } = _b, otherFields = __rest(_b, ["value"]), { fieldState: { error } } = _a;
                    return (_jsx(TextArea, Object.assign({ value: value }, otherFields, { label: subjectLabel, hasNecessityIndicator: required, maxCharacters: 2500, error: error === null || error === void 0 ? void 0 : error.message, isFullWidth: true, rows: 5, isDisabled: isPreviewMode })));
                } }))] }));
};
